export default __webpack_public_path__ + "static/media/mail.eb1eed46.png";